import { sendEmailChallenge } from '@client/new/api/auth.api';
import { PrimaryButton } from '@client/new/components/button';
import { navigate, PATHS } from '@client/routes';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router';
import { useLoginStore } from '../../../../stores/login.store';
import { AuthLayout } from '../../auth.layout';
import { trackEvent } from '@services/tracking';

export const CreatorLoginPage = () => {
  const { register, handleSubmit } = useForm();
  const { setEmail } = useLoginStore();

  const onSubmit = useCallback(async (event: any) => {
    const email: string = event.email.trim().toLowerCase();
    sendEmailChallenge(email);
    setEmail(email);
    navigate(PATHS.LOGIN_CONFIRMATION_CODE);
  }, []);

  const handleSignUpClick = () => {
    trackEvent({
      type: 'Sign Up',
      payload: {},
    });
  };

  return (
    <AuthLayout title={'Sign in to Playbook'}>
      <div className="flex flex-col items-center">
        <form className="mt-8 w-full" onSubmit={handleSubmit(onSubmit)}>
          <input
            aria-label="Email address"
            type="email"
            required
            className="input w-full text-center"
            placeholder="Type your email"
            {...register('email', { required: true })}
          />
          <div className="w-full mt-5">
            <PrimaryButton large type="submit">
              Continue
            </PrimaryButton>
          </div>
        </form>
        <p className="mt-10">
          {"We'll send you a code to sign in - no password required!"}
        </p>
        <p className="mt-5">
          <span className="font-bold">{"Don't have an account?"}</span>{' '}
          <Link className="link" to={'/sign-up'} onClick={handleSignUpClick}>
            Sign up
          </Link>
        </p>
      </div>
    </AuthLayout>
  );
};
